module.exports = __webpack_public_path__ + "assets/5b442c99573e8b7d1943a7f2f2060b2b.mp3";